import * as rewardConst from "./constants";
// import transform from './transform';
import { makeCall } from "@/utils/request";
import { buildOptions, getEndPoints } from "@/utils/api-call";
// import {
//   EVENT_TOAST_MESSAGE
// } from '@/store/events';
// import { EventBus } from '@/event-bus';
export const state = {
  historyProgram: [],
  historyEmployee: [],
  historyProgramPagination: {},
  historyEmployeePagination: {}
};

export const getters = {
  [rewardConst.GETTER_LIST_REWARD_HISTORY_PROGRAM]: state => {
    return state.historyProgram;
  },
  [rewardConst.GETTER_LIST_REWARD_HISTORY_PROGRAM_PAGINATION]: state => {
    return state.historyProgramPagination;
  },
  [rewardConst.GETTER_LIST_REWARD_HISTORY_EMPLOYEE]: state => {
    return state.historyEmployee;
  },
  [rewardConst.GETTER_LIST_REWARD_HISTORY_EMPLOYEE_PAGINATION]: state => {
    return state.historyEmployeePagination;
  }
};

export const actions = {
  [rewardConst.ACTION_GET_LIST_REWARD_HISTORY_PROGRAM]: (
    { commit },
    options
  ) => {
    if (options && options.programId && options.programId > 0) {
      const url = getEndPoints().program_rewards.getListProgramRewardHistory.replace(
        ":programId",
        options.programId
      );
      makeCall(url, buildOptions("GET", options.params), commit).then(
        response => {
          if (response.data) {
            commit(
              rewardConst.MUTATION_SET_LIST_REWARD_HISTORY_PROGRAM,
              response
            );
          }
        }
      );
    }
  },
  [rewardConst.ACTION_GET_LIST_REWARD_HISTORY_EMPLOYEE]: (
    { commit },
    options
  ) => {
    if (options && options.employeeId) {
      const url = getEndPoints().program_rewards.getListEmployeeRewardHistory.replace(
        ":employeeId",
        options.employeeId
      );
      makeCall(url, buildOptions("GET", options.params), commit).then(
        response => {
          if (response.data) {
            commit(
              rewardConst.MUTATION_SET_LIST_REWARD_HISTORY_EMPLOYEE,
              response
            );
          }
        }
      );
    }
  }
};

export const mutations = {
  [rewardConst.MUTATION_SET_LIST_REWARD_HISTORY_PROGRAM]: (
    state,
    programHistory
  ) => {
    state.historyProgram = programHistory.data;
    state.historyProgramPagination =
      programHistory.meta && programHistory.meta.pagination
        ? {
            ...{
              count: programHistory.meta.pagination.count,
              total: parseInt(programHistory.meta.pagination.total),
              itemsPerPage: programHistory.meta.pagination.per_page,
              totalPage: programHistory.meta.pagination.total_pages,
              current_page: parseInt(
                programHistory.meta.pagination.current_page
              )
            }
          }
        : state.historyProgramPagination;
  },

  [rewardConst.MUTATION_SET_LIST_REWARD_HISTORY_EMPLOYEE]: (
    state,
    employeeHistory
  ) => {
    state.historyEmployee = employeeHistory.data;
    state.historyEmployeePagination =
      employeeHistory.meta && employeeHistory.meta.pagination
        ? {
            ...{
              count: employeeHistory.meta.pagination.count,
              total: parseInt(employeeHistory.meta.pagination.total),
              itemsPerPage: employeeHistory.meta.pagination.per_page,
              totalPage: employeeHistory.meta.pagination.total_pages,
              current_page: parseInt(
                employeeHistory.meta.pagination.current_page
              )
            }
          }
        : state.historyEmployeePagination;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/basic_program_rewards_history/index.js